<div class="modal-dialog modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <h6 class="modal-title" i18n>Availability Config</h6>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>

    <div class="modal-body">
      <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center py-5">
        <i class="far fa-spinner fa-spin fa-2x text-muted"></i>
      </div>

      <form *ngIf="!isLoading" [formGroup]="form">
        <div class="row">
          <div class="col-md-6">
            <mat-form-field2 class="mat-block">
              <mat-label i18n>Advance Notice Time (Days)</mat-label>
              <input
                matInput
                type="number"
                min="0"
                max="999"
                formControlName="min_prior_notify"
                placeholder="0 = no notice required"
                i18n-placeholder
              />
              <mat-error *ngIf="form.get('min_prior_notify').hasError('required')" i18n>
                Advance notice is required
              </mat-error>
              <mat-error *ngIf="form.get('min_prior_notify').hasError('min')" i18n> Must be 0 or more </mat-error>
              <mat-error *ngIf="form.get('min_prior_notify').hasError('max')" i18n> Must be 999 or less </mat-error>
            </mat-form-field2>
          </div>

          <div class="col-md-6">
            <mat-form-field2 class="mat-block">
              <mat-label i18n>Available by Default</mat-label>
              <mat-select formControlName="availability_default">
                <mat-option value="Y" i18n>Yes</mat-option>
                <mat-option value="N" i18n>No</mat-option>
              </mat-select>
            </mat-form-field2>
          </div>

          <div class="col-md-6">
            <mat-form-field2 class="mat-block">
              <mat-label i18n>Minimum Stay (Nights)</mat-label>
              <input
                matInput
                type="number"
                min="0"
                max="999"
                formControlName="min_stay"
                placeholder="0 = use rental settings"
                i18n-placeholder
              />
              <mat-error *ngIf="form.get('min_stay').hasError('min')" i18n>Must be 0 or more</mat-error>
              <mat-error *ngIf="form.get('min_stay').hasError('max')" i18n>Must be 999 or less</mat-error>
            </mat-form-field2>
          </div>

          <div class="col-md-6">
            <mat-form-field2 class="mat-block">
              <mat-label i18n>Maximum Stay (Nights)</mat-label>
              <input
                matInput
                type="number"
                min="0"
                max="999"
                formControlName="max_stay"
                placeholder="0 = use rental settings"
                i18n-placeholder
              />
              <mat-error *ngIf="form.get('max_stay').hasError('min')" i18n>Must be 0 or more</mat-error>
              <mat-error *ngIf="form.get('max_stay').hasError('max')" i18n>Must be 999 or less</mat-error>
            </mat-form-field2>
          </div>

          <div class="col-md-6">
            <mat-form-field2 class="mat-block">
              <mat-label i18n>Change Over</mat-label>
              <mat-select formControlName="change_over">
                <mat-option *ngFor="let opt of changeOverOptions" [value]="opt.value">{{ opt.label }}</mat-option>
              </mat-select>
            </mat-form-field2>
          </div>

          <div class="col-md-6">
            <mat-form-field2 class="mat-block">
              <mat-label i18n>Stay Increment</mat-label>
              <mat-select formControlName="stay_increment">
                <mat-option *ngFor="let opt of stayIncrementOptions" [value]="opt.value">{{ opt.label }}</mat-option>
              </mat-select>
            </mat-form-field2>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()" i18n>Cancel</button>
      <button
        type="button"
        class="btn btn-secondary-success"
        [disabled]="form?.invalid || isSaving || isLoading"
        (click)="onSave()"
      >
        <i *ngIf="isSaving" class="far fa-spinner fa-spin"></i>
        <ng-container i18n>Save</ng-container>
      </button>
    </div>
  </div>
</div>
